import { render, staticRenderFns } from "./PartnershipModal.vue?vue&type=template&id=0225106a&"
import script from "./PartnershipModal.vue?vue&type=script&lang=js&"
export * from "./PartnershipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports